import {
  GET_TASKDETAIL,
  GET_TASKDETAIL_SUCCESS,
  GET_TASKDETAIL_FAIL,
  DELETE_TASKDETAIL,
  DELETE_TASKDETAIL_SUCCESS,
  DELETE_TASKDETAIL_FAIL,
  UPDATE_TASKDETAIL,
  UPDATE_TASKDETAIL_SUCCESS,
  UPDATE_TASKDETAIL_FAIL,
  ADD_NEW_TASKDETAIL,
  ADD_TASKDETAIL_SUCCESS,
  ADD_TASKDETAIL_FAIL,
  TASKDETAIL_LOADING,
  TASKDETAIL_RESET,
} from "./actionType";

export const resetTaskDetailState = (actionType) => ({
  type: TASKDETAIL_RESET,
  payload: { actionType },
});

export const getTaskDetailSuccess = (actionType, data) => ({
  type: GET_TASKDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getTaskDetailFail = (actionType, error) => ({
  type: GET_TASKDETAIL_FAIL,
  payload: { actionType, error },
});

export const getTaskDetail = data => ({
  type: GET_TASKDETAIL,
  payload: data,
});

export const getTaskDetailLoading = () => ({
  type: TASKDETAIL_LOADING
});

export const deleteTaskDetail = data => ({
  type: DELETE_TASKDETAIL,
  payload: data,
});

export const deleteTaskDetailSuccess = data => ({
  type: DELETE_TASKDETAIL_SUCCESS,
  payload: data,
});

export const deleteTaskDetailFail = error => ({
  type: DELETE_TASKDETAIL_FAIL,
  payload: error,
});

export const updateTaskDetail = data => ({
  type: UPDATE_TASKDETAIL,
  payload: data,
});

export const updateTaskDetailFail = error => ({
  type: UPDATE_TASKDETAIL_FAIL,
  payload: error,
});

export const updateTaskDetailSuccess = data => ({
  type: UPDATE_TASKDETAIL_SUCCESS,
  payload: data,
});

export const addNewTaskDetail = data => ({
  type: ADD_NEW_TASKDETAIL,
  payload: data,
});

export const addTaskDetailSuccess = data => ({
  type: ADD_TASKDETAIL_SUCCESS,
  payload: data,
});

export const addTaskDetailFail = error => ({
  type: ADD_TASKDETAIL_FAIL,
  payload: error,
});